import { useState } from "react";
import { toast } from "sonner";
import { authApi, apiErr } from "./api";
import { PageHeader, TextInput, Button, Card } from "./ui";
import { KeyRound, Loader2 } from "lucide-react";
import { useAdminAuth } from "./AdminAuth";
import { useNavigate } from "react-router-dom";

export default function AdminChangePassword() {
  const [c, setC] = useState("");
  const [n, setN] = useState("");
  const [n2, setN2] = useState("");
  const [busy, setBusy] = useState(false);
  const { logout } = useAdminAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (n !== n2) return toast.error("Yeni şifreler eşleşmiyor");
    if (n.length < 8) return toast.error("Yeni şifre en az 8 karakter olmalı");
    setBusy(true);
    try {
      await authApi.changePassword(c, n);
      toast.success("Şifre güncellendi. Tekrar giriş yapın.");
      logout();
      nav("/dekosta-yonetim/login");
    } catch (err) { toast.error(apiErr(err)); }
    finally { setBusy(false); }
  };

  return (
    <div>
      <PageHeader title="Şifre Değiştir" description="Admin hesabınızın şifresini güncelleyin." />
      <Card className="p-8 max-w-xl">
        <form onSubmit={submit} className="space-y-5" data-testid="pw-form">
          <TextInput label="Mevcut Şifre" type="password" value={c} onChange={(e) => setC(e.target.value)} testid="pw-current" required />
          <TextInput label="Yeni Şifre (min 8)" type="password" value={n} onChange={(e) => setN(e.target.value)} testid="pw-new" required />
          <TextInput label="Yeni Şifre (Tekrar)" type="password" value={n2} onChange={(e) => setN2(e.target.value)} testid="pw-new2" required />
          <Button type="submit" disabled={busy} data-testid="pw-submit">
            {busy ? <><Loader2 className="w-4 h-4 animate-spin" /> Kaydediliyor…</> : <><KeyRound className="w-4 h-4" /> Şifreyi Güncelle</>}
          </Button>
        </form>
      </Card>
    </div>
  );
}
